<template>
  <div class="vs-con-loading__container">
    <div class="vx-row">
      <div class="vx-col w-full mb-4">
        <vs-input
          label="Заголовок *"
          class="w-full"
          v-model="title"
          :danger="errors.title"
          danger-text="Обязательное поле"
          @input="errors.title = false"
        />
      </div>

      <div class="vx-col w-full mb-4">
        <label for="add-news-text" class="vs-input--label">Текст</label>
        <elsa-quill-editor v-model="text" class="news-editor" id="add-news-text" />
        <!--                <quill-editor v-model="text" class="news-editor" id="add-news-text" />-->
      </div>

      <div class="vx-col w-full mb-4">
        <label class="vs-input--label">Обложка *</label>
        <div :class="$style.tabs" v-if="images">
          <div :class="$style.tabsHeaders">
            <div
              v-for="category in images"
              :key="category.id"
              :class="[$style.tabsHeader, category.id === selectedImageCategory && $style.tabsHeaderActive]"
              @click="selectedImageCategory = category.id"
            >
              {{ category.title }}
            </div>
          </div>
          <div v-if="images[selectedImageCategory]" :class="$style.tabsBody" ref="images">
            <div
              v-for="image in images[selectedImageCategory].items"
              :key="image.id"
              :ref="selectedImage === image.id ? 'selectedImage' : undefined"
              :class="[$style.item, selectedImage === image.id && $style.itemActive]"
              @click="onSelectImage(image)"
            >
              <div :class="$style.image" :style="{backgroundImage: `url(${imageSrc(image)})`}" />
              <app-icon name="CheckIcon" :class="$style.icon" size="30" />
            </div>
          </div>
        </div>
        <div v-if="errors.selectedImage" :class="$style.errorText">Обязательное поле</div>
      </div>

      <div class="vx-col w-full mb-4 flex justify-center">
        <vs-button type="border" color="success" @click="onSubmitForm">
          {{ data ? 'Сохранить' : 'Добавить' }}
        </vs-button>
      </div>

    </div>
  </div>
</template>

<script>
import modal           from "@/mixins/modalContext";
import arrayToIdIndex  from "@/client/helpers/arrayToIdIndex";
import NotifyHttpError from "@/mixins/notifyHttpError";
import ElsaQuillEditor from "@/components/ElsaQuillEditor";

export default {
  name:       "NewsEditForm",
  components: { ElsaQuillEditor },
  mixins:     [NotifyHttpError, modal],
  props:      ['data', 'onSubmit', 'onBeforeClose'],
  data() {
    return {
      images:                null,
      selectedImageCategory: 0,
      selectedImage:         null,
      title:                 '',
      text:                  '',
      errors:                {
        title:         false,
        selectedImage: false,
      },
      saveInProgress:        false,
    };
  },
  computed:   {
    isHasErrors() {
      for (let field in this.errors) {
        if (this.errors[field]) return true;
      }
      return false;
    },
  },
  methods:    {
    loadImages() {
      this.$http.get('news_catalog').then(( { data } ) => {
        this.images = arrayToIdIndex(data);
        if (this.selectedImage) this.$nextTick(() => {
          const { images, selectedImage } = this.$refs;
          if (!images || !selectedImage.length) return;
          images.scrollTop = selectedImage[0].offsetTop - 50;
        });
      });
    },
    onSelectImage( image ) {
      this.selectedImage = image.id;
      this.errors.selectedImage = null;
    },
    onSubmitForm() {
      if (this.saveInProgress) return;
      const { title, text, selectedImage, onSubmit } = this;
      if (!title.trim().length) this.errors.title = true;
      if (!selectedImage) this.errors.selectedImage = true;
      if (this.isHasErrors) return false;

      let data = new FormData();
      data.append('title', title || '');
      data.append('text_news', text || '');
      if (selectedImage) data.append('image_category_item', selectedImage);
      data.append('users_id', this.$store.getters['appUser/id']);

      if (onSubmit) {
        this.saveInProgress = true;
        onSubmit(data).then(
          () => this.modalResolve(),
          this.notifyHttpError,
        ).finally(() => {
          this.saveInProgress = false;
        });
      }
    },

    changeAlert() {
      return new Promise(( resolve, reject ) => {
        this.$vs.dialog({
          type:       'confirm',
          color:      'danger',
          title:      'В форме остались несохраненные данные',
          text:       'Отменить изменения?',
          acceptText: 'Да',
          cancelText: 'Нет',
          accept:     resolve,
          cancel:     reject,
        });
      });
    },
    onBeforeCloseCheck() {
      if (this.saveInProgress) return Promise.reject();
      if (this.data) {
        if (
          this.title !== this.data.title ||
          this.text !== this.data.text_news ||
          (this.data.image_item && this.selectedImage !== this.data.image_item.id)
        ) return this.changeAlert();
      } else {
        if (this.title || this.text || this.selectedImage) return this.changeAlert();
      }
      return Promise.resolve();
    },

    imageSrc( image ) {
      return this.$options.filters.imgPath(image['337x250'] || image.original);
    },
  },
  mounted() {
    this.loadImages();
    this.onBeforeClose(this.onBeforeCloseCheck);

    if (this.data) {
      const { title, text_news, image_item } = this.data;
      this.title = title;
      this.text = text_news;
      if (image_item) {
        this.selectedImageCategory = image_item.category;
        this.selectedImage = image_item.id;
      }
    }
  },
  watch:      {
    saveInProgress( saveInProgress ) {
      if (saveInProgress) {
        this.$vs.loading({ container: this.$el });
      } else {
        this.$vs.loading.close(this.$el);
      }
    },
  },
};
</script>

<style lang="scss" module>
.tabs {
  border: 1px solid #ccc;
  height: 320px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
}

.tabsHeaders {
  border-right: 1px solid #ccc;
  width: 200px;
  flex-shrink: 0;
  overflow: auto;
  height: 100%;
}

.tabsHeader {
  padding: 8px 12px;
  cursor: pointer;
  @include anim();

  &:hover {
    background: rgba(#ccc, .5);
  }
}

.tabsHeaderActive {
  &, &:hover {
    background: #ccc;
  }
}

.tabsBodies {
  height: 100%;
}

.tabsBody {
  position: relative;
  max-height: 100%;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  flex: 1;
}

.item {
  padding: 5px;
  width: 33.3333%;
  position: relative;
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    top: 5px;
    right: 5px;
    bottom: 5px;
    left: 5px;
    border: 1px solid color(success);
    background: rgba(#fff, .5);
    opacity: 0;
    //border-radius: 3px;
    @include anim();
  }

  &:hover {
    &:before {
      opacity: .5;
    }
  }
}

.itemActive {
  &, &:hover {
    &:before {
      opacity: 1;
    }

    .icon {
      opacity: 1;
    }
  }
}

.image {
  padding-bottom: 58.5%;
  background-color: rgba(#ccc, .1);
  background-size: cover;
  background-position: 50% 50%;
  //border-radius: 3px;
}

.icon {
  position: absolute;
  top: 50%;
  left: 50%;
  fill: color(success);
  transform: translate(-50%, -50%);
  @include anim();
  opacity: 0;
}

.errorText {
  position: relative;
  font-size: .65rem;
  overflow: hidden;
  transition: all .25s ease;
  color: rgba(var(--vs-danger), 1);
  padding: 2px 4px 4px;
  display: block;
}

</style>
